// WDCE-199 step 9f: the PIN pad's display, as Linkly sends it: lines joined with \n, each padded with spaces to centre
// it on a 20-character screen. Gives the lines trimmed, without blank lines at the start and end (blank lines in the
// middle are kept, as the PIN pad shows them). Nothing gives [].
export function displayLines(text) {
  if (typeof text !== 'string') return []

  const lines = text.split('\n').map((line) => line.trim())
  let start = 0
  let end = lines.length
  while (start < end && lines[start] === '') start += 1
  while (end > start && lines[end - 1] === '') end -= 1
  return lines.slice(start, end)
}
